import { TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { MateNode } from '@kb3d/models/classes/mates/mate-node';
import { Token } from '@kb3d/models/classes/token';
import { ITrackedClass } from '@kb3d/models/interfaces';
import { SyncService } from '@kb3d/models/services/sync-service';
import { Renderer } from './renderer';

export class MateRenderer extends Renderer<MateNode, TransformNode> {
    modelToken = Token.MateNode;

    update3dInternal(node: ITrackedClass<MateNode>) {}
    delete3d(node: ITrackedClass<MateNode>) {
        SyncService.nodeDeletionProcessed(node);
    }
}
